import {createAction} from 'redux-act'

export const setSimpleTransferModalVisible = createAction('SET_SIMPLE_TRANSFER_MODAL_VISIBLE')
export const setSimpleTransferForm = createAction('SET_SIMPLE_TRANSFER_FORM')
export const closeSimpleTransferForm = createAction('CLOSE_SIMPLE_TRANSFER_FORM')



